/**
 * "Completed this session" piles, per list. Vikunja behavior: a task checked
 * during this session stays visible (grayed, sunk to the bottom); a reload or
 * the manual clear removes it from the list view, after which it lives only
 * in the dashboard's completed history. Deliberately NOT persisted; a page
 * load starting clean IS the feature.
 *
 * Remote completions enter the pile too: a teammate's checkmark animates and
 * sinks like yours instead of the row blinking out of existence.
 */
import { create } from "zustand";

interface SessionDoneState {
  /** listId -> taskIds completed this session, in completion order. */
  piles: Record<string, string[]>;
  add: (listId: string, taskId: string) => void;
  remove: (listId: string, taskId: string) => void;
  clearList: (listId: string) => void;
}

export const useSessionDone = create<SessionDoneState>((set) => ({
  piles: {},
  add: (listId, taskId) =>
    set((s) => {
      const pile = s.piles[listId] ?? [];
      if (pile.includes(taskId)) return s;
      return { piles: { ...s.piles, [listId]: [...pile, taskId] } };
    }),
  remove: (listId, taskId) =>
    set((s) => {
      const pile = s.piles[listId];
      if (!pile?.includes(taskId)) return s;
      return { piles: { ...s.piles, [listId]: pile.filter((id) => id !== taskId) } };
    }),
  clearList: (listId) =>
    set((s) => {
      if (!s.piles[listId]?.length) return s;
      return { piles: { ...s.piles, [listId]: [] } };
    }),
}));
